/**
 *
 * RegisterDate
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { format, isBefore } from 'utils/date-fns/index.js';

import { FormattedMessage } from 'react-intl';

function RegisterDate(props) {
  const { date, msgPast, msgNone, open } = props;
  if (msgPast && isBefore(date, new Date())) {
    return <span className="date-past"><FormattedMessage {...msgPast} /></span>;
  }
  if (open) {
    return msgNone ? <span className="date-none"><FormattedMessage {...msgNone} /></span> : null;
  }
  return <span className="formatted-date">{format(date, 'PPPp')}</span>;
}

RegisterDate.propTypes = {
  date: PropTypes.object,
  msgPast: PropTypes.object,
  msgNone: PropTypes.object,
  open: PropTypes.bool,
};

export default RegisterDate;
